import styled from 'styled-components';

const Image = styled.img`
	display: block;
	height: calc(100vh - 150px);
	margin: 0 auto;
`;

export { Image };
